import React from 'react';

export interface NotificationContextState {
  desktopNotificationsEnabled: boolean;
  enableDesktopNotifications: (val: boolean) => void;
  showDesktopNotificationsToast: () => void;
  requestPermission: () => Promise<NotificationPermission | undefined>;
  supportsNotifications: boolean;
  showInstructionsModal: boolean;
  closeModal: () => void;
}

export const NotificationContext = React.createContext<NotificationContextState>(
  {} as unknown as NotificationContextState
);
